// Accordion labels switched to sentence case (acronyms kept).
import React, { FC } from 'react';

import { Accordion } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { IconTypes } from 'components/Icons/types';
import { RoleChainingTimeline } from 'components/Visualization/RoleChainingTimeline';
import { MetaAccordionItem } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetaAccordionItem';
import { ResourceActionsPatternAccordion } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/ResourceActionsPatternAccordion';
import { ResourceAccessPatternAccordion } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Access/ResourceAccessPatternAccordion';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

export const IAMUserActivity: FC = () => {
  const { resourceType, resourceAccountId, resourceUuid } = useSelector(
    selectActiveResource,
  );

  const columns = [
    { header: 'ACCESS KEY' },
    { header: 'SERVICE ACCESSED' },
    { header: 'TIMESTAMP' },
    { header: 'ACTION PERFORMED' },
    { header: 'SOURCE IP' },
    { header: 'ANOMALY' },
  ];

  return (
    <Accordion allowMultiple defaultIndex={[0]}>
      <ResourceAccessPatternAccordion />
      <ResourceActionsPatternAccordion />
      <MetaAccordionItem
        iconType={IconTypes.DataScan}
        label={'Actions using role chaining'}
        onClickDownload={() => {}}
        panel={
          <RoleChainingTimeline
            accountId={resourceAccountId}
            entityId={resourceUuid}
            resourceType={resourceType}
          />
        }
        iconBGColor="primary"
      />
      <MetaAccordionItem
        iconType={IconTypes.CloudActivity}
        label={'Actions using role over past 30 days'}
        onClickDownload={() => {}}
        panel={<Table columns={columns} data={[]} />}
        iconBGColor="primary"
      />
    </Accordion>
  );
};
